/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface CallbackRunRequest
 */
export interface CallbackRunRequest {
  /**
   *
   * @type {string}
   * @memberof CallbackRunRequest
   */
  callbackCode: string;
}

/**
 * Check if a given object implements the CallbackRunRequest interface.
 */
export function instanceOfCallbackRunRequest(value: object): value is CallbackRunRequest {
  if (!('callbackCode' in value) || value['callbackCode'] === undefined) return false;
  return true;
}

export function CallbackRunRequestFromJSON(json: any): CallbackRunRequest {
  return CallbackRunRequestFromJSONTyped(json, false);
}

export function CallbackRunRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CallbackRunRequest {
  if (json == null) {
    return json;
  }
  return {
    callbackCode: json['callback_code']
  };
}

export function CallbackRunRequestToJSON(value?: CallbackRunRequest | null): any {
  if (value == null) {
    return value;
  }
  return {
    callback_code: value['callbackCode']
  };
}
